require('./angular-scroll-magic');

module.exports = 'hj.scrollMagic';
